<h1 mat-dialog-title [innerHtml]="data.title"></h1>

<div mat-dialog-content>
  <p [innerHtml]="data.message"></p>
</div>

<div class="flex flex-row-reverse space-x-4 space-x-reverse p-4">
    <span class="bee-button primary" (click)="close(true)">Ok</span>
    <span class="bee-button secondary" (click)="close(false);">Avbryt</span>
</div>